import logo from './logo.svg';
import './App.css';
import FrontArt from './components/frontart';

function App() {
  return (
    <div className="App">
      <FrontArt />
    </div>
  );
}

export default App;

{/* <iframe id="inlineFrameExample"
    title="Inline Frame Example"
    width="300"
    height="200"
    src="https://6huyaaz7zbwgcrjcupqat323fkltb6iebcc77tczpx4cggx5oleq.arweave.net/8emAAz_IbGFFIqPgCe9bKpcw-QQIhf_MWX34Ixr9csk/index.html">
</iframe> */}